webpackJsonp([125224498179462],{

/***/ 1475:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"NewsletterInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"audience","type":{"kind":"SCALAR","name":"JSON","ofType":null}},{"defaultValue":null,"description":null,"name":"body","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"from","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"subject","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-newsletter-input-c68c428802b30d0c9774.js